import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import { Title, Spinner } from "../../components/atoms";
import { apiGet, apiPost } from "../../utils/services";
import { ACCEPTPRODUCTPRICE } from "../../api/apiConfig";
import { Toaster, toast } from 'react-hot-toast';
import { Button, FormControlLabel, Grid, Paper, Radio, RadioGroup, Stack, Table, TableBody, TableCell, TableHead, TableRow, TableContainer, Tooltip, Popover,  Dialog, DialogTitle, Snackbar,  DialogContent, useMediaQuery} from "@mui/material";



const AcceptTopDealProductPrice = () => {
  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState(false);
  const [screenClicked, setScreenClicked] = useState(false);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const productId = queryParams.get('productId');
  const price = queryParams.get('price');
  const campaignId = queryParams.get('campaignId');
  const oldPrice = queryParams.get('oldPrice');
  const action = queryParams.get('accept');
  const navigate = useNavigate();
  useEffect(() => {
    const handleClick = () => {
      // Do something when the screen is clicked
      console.log('Screen Clicked!');
      setScreenClicked(true); // Example: Update state when the screen is clicked
    };

    // Attach click event listener to the document
    document.addEventListener('click', handleClick);

    // Cleanup function to remove event listener when component unmounts
    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, []);
  const wait = (ms) => new Promise(res => setTimeout(res, ms));

 
  
   
  
  useEffect( async () => {
    if(action === "true")
    {
        try
        {   
            let requestBody = { productId:parseInt(productId), Price:parseFloat(price).toFixed(2),  campaignId: parseInt(campaignId), oldPrice: parseFloat(oldPrice).toFixed(2)};
            
            console.log("making requests---------", requestBody);
            const res = await apiPost(ACCEPTPRODUCTPRICE, requestBody);
             if(res)
             {
                 
                setLoading(false);
                setSuccess(true);
             }
             
        }
        catch(error)
        {
            setLoading(false);
        }
    }
    else
    {

        setLoading(false);
        setSuccess(true);
    }
   
    
    await wait(2000); 
    navigate("/dashboard");
}, []);

 
  const DisplaySpinner = () => {

    return (
      <div className="spinnerDiv">
        <Spinner color={"black"} loading={true} size={50} />
      </div>
    );
  };

 
  
  return (
    <div>
         {loading && (<div
                                style={{
                                position: 'fixed',
                                top: 0,
                                left: 0,
                                width: '100%',
                                height: '100%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                backgroundColor: 'rgba(255, 255, 255, 0.8)', 
                                zIndex: 9999,
                                }}
                            >
                        <DisplaySpinner />
                        
                        </div>)}
        <Paper>
            <div style={{width:'300px'}}>
                <Title>
                    {success && (<h>
                     Successful
                    </h>)}
                </Title>
            </div>
        </Paper>
        
    </div>
  );
};
export default AcceptTopDealProductPrice;
